import React, {useState} from 'react';
import {Card, Tabs} from "antd";
import {useSelector} from "react-redux";

import TableTabBalanceManager from "./TableTabBalanceManager";
import TableTabBalanceCustomer from "./TableTabBalanceCustomer";
import TableTabCredit from "./TableTabCredit";
import AppNotificationContainer from "../../components/AppNotificationContainer";
import IntlMessages from "../../util/IntlMessages";

const BalanceComponent = () => {
    const { authUser } = useSelector(state => state.auth);
    const [activeTab, setActiveTab] = useState('tab1');

    const tabItems = [
        {
            key: 'tab1',
            label: <IntlMessages id="balance.balanceApp.myBalance" />,
            children: <TableTabBalanceCustomer stateTab={activeTab} />,
        },
        {
            key: 'tab2',
            label: <IntlMessages id="balance.balanceApp.attachedAccounts" />,
            children: <TableTabBalanceManager stateTab={activeTab} />,
        },
        {
            key: 'tab3',
            label: <IntlMessages id="balance.balanceApp.creditBalance" />,
            children: <TableTabCredit stateTab={activeTab} />,
        },
    ];

    return (
        <>
            <Card title={<IntlMessages id="balance.balanceApp.historyBalance" />}>
                {authUser.is_staff ? (
                    <Tabs
                        defaultActiveKey="tab1"
                        activeKey={activeTab}
                        items={tabItems}
                        onChange={setActiveTab}
                    />
                ) : (
                    <TableTabBalanceCustomer stateTab={activeTab} />
                )}
            </Card>
            <AppNotificationContainer />
        </>
    );
};

export default BalanceComponent;